import MissionPage from 'containers/mission'

export default MissionPage

export const getStaticProps = async () => ({
  props: {
    pageTitle: 'Claws',
  },
})
